export default __webpack_public_path__ + "static/media/043-wine.54b58620.svg";